import { HttpClient } from '@angular/common/http';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { URL_RETRIEVE_PARAMS, MOCK_URL_PARAMS, MOCK_STATUS } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
var ParamsIndraService = /** @class */ (function () {
    function ParamsIndraService(http, api) {
        this.http = http;
        this.api = api;
    }
    ParamsIndraService.prototype.getParamByName = function (paramName) {
        if (MOCK_STATUS.PARAMS) {
            return this.http.get(MOCK_URL_PARAMS);
        }
        else {
            return this.api.INDRA_get("" + URL_RETRIEVE_PARAMS + "/" + paramName);
        }
    };
    ParamsIndraService.ngInjectableDef = i0.defineInjectable({ factory: function ParamsIndraService_Factory() { return new ParamsIndraService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService)); }, token: ParamsIndraService, providedIn: "root" });
    return ParamsIndraService;
}());
export { ParamsIndraService };
